import { todolists } from "../features/todolists/Todolists";
interface Field {
    title: string;
    name: keyof todolists; 
    type: string;
    width: number;
    height?: number; 
    isRequired: boolean;
    options?: string[];
  }
export const Todolistfields: Field[] = [
    
    {
      title: "Title",
      name: "title",
      type: "text",
      width: 450,
      height: 70,
      isRequired: false,
    },
    {
      title: "Project Name",
      name: "projectname",
      type: "dropDown",
      width: 450,
      isRequired: false,
      height: 70,
      options: [], 
    },
    {
      title: "Status",
      name: "status",
      type: "dropDown",
      width: 450,
      isRequired: false,
      options: ["Pending", "In progress", "Completed"],
    },
    {
      title: "Created By",
      name: "createdby",
      type: "text",
      height: 70,
      width: 350,
      isRequired: false,
    },
    {
      title: "Assigned To",
      name: "assignedto",
      type: "dropDown",
      width: 450,
      height: 70,
      isRequired: false,
      options:[],
    },
    {
      title: "Created Date",
      name: "createddate",
      type: "date",
      height: 70,
      width: 450,
      isRequired: false,
    },
    {
      title: " Description",
      name: "description",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    {
      title: "Priority",
      name: "priority",
      type: "dropDown",
      width: 450,
      isRequired: false,
      options: ["Low", "Normal", "High"],
    },
    {
      title: "Checklist",
      name: "checklist",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    {
      title: " Remarks",
      name: "remarks",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    {
      title: "Attachments",
      name: "attachments",
      type: "dropzone",
       width: 450,
       height: 100,
       isRequired: false,
    },
    {
      title: "Signature",
      name: "signature",
      type: "textArea",
       width: 450,
       height: 75,
       isRequired: false,
    },
    
];